import alt from 'framework/alt';
import TermsActions from 'actions/TermsActions';

class TermsStore {
  constructor() {
    this.bindListeners({
      fetchSucceeded: TermsActions.fetchSucceeded,
      fetchFailed: TermsActions.fetchFailed,
      setLegalData: TermsActions.setLegalData,
    });

    this.state = {
      terms: undefined,
      contentToken: undefined,
      privacyPolicyUrl: '',
      conditionsOfUseUrl: '',
      cookiePolicyUrl: '',
    };
  }

  fetchSucceeded(terms) {
    this.setState({
      terms: terms.text,
      contentToken: terms.contentToken,
    });
  }

  fetchFailed(err) {
    this.setState({
      error: err,
    });
  }

  setLegalData({
    privacyPolicyUrl, conditionsOfUseUrl, cookiePolicyUrl, termsAndConditionsKey,
  }) {
    this.setState({
      privacyPolicyUrl,
      conditionsOfUseUrl,
      cookiePolicyUrl,
      termsAndConditionsKey,
    });
  }
}

export default alt.createStore(TermsStore, 'TermsStore');
